var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('div',{staticClass:"animated-image",class:{
       'visible': _vm.visible
      },attrs:{"id":'animated-image-' + _vm.id}},[_c('img',{staticClass:"animated-image-bg",attrs:{"src":_vm.getImage(_vm.id),"alt":_vm.id}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }